import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IHoleResultsStore } from './store';

export interface IAdminHoleResultsActions {
  get: (
    roundId: number,
    formatId: number,
    force?: boolean
  ) => { holeResults?: IHoleResultsStore; errors?: IErrorsStore };
}

interface IGetFilter {
  hole: number;
}

const actions: IActionGroup = {
  get: async (state: IStore, roundId: number, filter?: IGetFilter, force?: boolean) => {
    if (state.holeResults[roundId] && !force) {
      return {
        holeResults: state.holeResults
      };
    }

    const response = await request.get(
      api.results('player', 'holes', { round_id: roundId, ...filter })
    );

    if (response.error) {
      return {
        errors: {
          holeResults: { msg: 'Error retrieving the Round Format Awards by Holes List.' }
        }
      };
    }

    return {
      holeResults: {
        ...state.holeResults,
        [roundId]: response
      }
    };
  }
};

export default actions;
